import { makeStyles } from '@mui/styles';
import { GridColDef } from '@mui/x-data-grid';
import React from 'react';

import DataGrid from '#app/Component/DataGrid';
import { transformObjectToDataGridRowsArray } from '#app/Util/DataGridDataTransformer';
import { momentDateFormatter } from '#app/Util/MomentDateFormatter';
import { formatNumberToEurCurrency } from '#app/Util/NumberTool';
import { momentDateComparator } from '#app/Util/SortMomentDate';
import { floatSortComparator } from '#app/Util/SortNumber';
import { Filters } from '#app/View/Accounting';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { ShopPayment } from '#app/typings/orderClient';

type Props = Omit<ReturnType<typeof useCollectionPaginated<ShopPayment, Filters>>, 'setFilters' | 'filters'>;

const List: React.FC<Props> = ({
  data: shopPayments,
  totalItems,
  loading,
  pagination,
  sorting,
  setPagination,
  setSorting,
}) => {
  const classes = useStyles();

  const columns: GridColDef[] = [
    {
      field: 'orderNumber',
      headerName: 'Cmd Référence',
      minWidth: 160,
    },
    {
      field: 'confirmedAt',
      headerName: 'Date de confirmation',
      minWidth: 120,
      align: 'right',
      sortComparator: momentDateComparator,
      valueGetter: (value) => momentDateFormatter.dateTimeToFormatFr(value),
    },
    {
      field: 'shopName',
      headerName: 'Nom de boutique',
      minWidth: 250,
    },
    {
      field: 'shopCard',
      headerName: 'Montant payé en CB',
      headerAlign: 'right',
      minWidth: 150,
      align: 'right',
      sortComparator: floatSortComparator,
      valueGetter: (value) => formatNumberToEurCurrency(value),
    },
    {
      field: 'shopCash',
      headerName: 'Montant payé en espèce',
      headerAlign: 'right',
      minWidth: 150,
      align: 'right',
      sortComparator: floatSortComparator,
      valueGetter: (value) => formatNumberToEurCurrency(value),
    },
    {
      field: 'shopAvoir',
      headerName: 'Montant avoir',
      headerAlign: 'right',
      minWidth: 150,
      align: 'right',
      sortComparator: floatSortComparator,
      valueGetter: (value) => formatNumberToEurCurrency(value),
    },
    {
      field: 'cashBack',
      headerName: 'Montant rendu',
      headerAlign: 'right',
      minWidth: 150,
      align: 'right',
      sortComparator: floatSortComparator,
      valueGetter: (value) => formatNumberToEurCurrency(value),
    },
    {
      field: 'priceHT',
      headerName: 'Montant HT commande',
      headerAlign: 'right',
      minWidth: 150,
      align: 'right',
      sortComparator: floatSortComparator,
      valueGetter: (value) => formatNumberToEurCurrency(value),
    },
    {
      field: 'priceTTC',
      headerName: 'Montant TTC commande',
      headerAlign: 'right',
      minWidth: 150,
      flex: 1,
      align: 'right',
      sortComparator: floatSortComparator,
      valueGetter: (value) => formatNumberToEurCurrency(value),
    },
  ];

  return (
    <DataGrid
      className={classes.container}
      rows={transformObjectToDataGridRowsArray<ShopPayment>(shopPayments)}
      columns={columns}
      loading={loading}
      rowCount={totalItems}
      pagination={pagination}
      setPagination={setPagination}
      sorting={sorting}
      setSorting={setSorting}
    />
  );
};

const useStyles = makeStyles({
  container: {
    marginTop: 15,
  },
});

export default List;
